module.exports = {
  "CS_FE_Select_Product_VbhT": "「PM and DEV Role」を選択してください",
  "CS_status_Dibi_hJVY": "続ける（{{time_second}}）",
  "CS_system_Submission_cEep": "送信",
  "CS_1_WiFi_pyYD": "Wi-Fi",
  "CS_FE_You_can_yIrn": "下から必要な権限タイプを選択して「適用」をクリックしてください。",
  "CS_status_SYOk_iYUs": "B2B",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_See_permissions_OzjQ": "詳しくは、カスタマーサービスシステムアクセスガイドラインをご参照ください。",
  "CS_status_ZoGi_sjyC": "ドライバーセンター",
  "CS_1_Environment_Bitb": "環境",
  "CS_1_View_Current_IOCz": "現在の権限を表示",
  "CS_optimazation__CALn": "無操作状態のため、ステータスが自動的にオフラインになりました。ページを更新してください。",
  "CS_1_Upgrade_current_dlbi": "現在の権限を引き上げ",
  "CS_optimazation_You_have_PlRk": "{{workbench_name}}が{{time_duration}}分間アイドリング状態になっています。{{workbench_name}}での作業を続行しますか？",
  "CS_optimazation__akmu": "オフライン",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_oPui": "カスタマーサービス担当以外の場合：",
  "CS_status_ixVR_bjQc": "営業",
  "CS_feedback_Feedback_bGXI": "フィードバック",
  "CS_optimazation__ZkZb": "{{work_status}}でいる",
  "CS_System_ZQjn_eCbz": "過去のトレーニング済みスキルタイプ",
  "CS_status_CjDQ_uaVo": "不正防止",
  "CS_Status_In_the_PrHj": "トイレ休憩中",
  "CS_1_Thank_you_WUlL": "フィードバックありがとうございます。",
  "CS_status_ErSl_RYFT": "発信",
  "CS_1_Log_in_sMmF": "ログアウト",
  "CS_status_HxNd_EpND": "ドライブレコーダー",
  "CS_status_HMDn_eBqC": "エンゲージメント",
  "CS_status_zoxI_Nral": "現在のサービスタイプは{{service_type}}です",
  "CS_feedback_1_Please_IBbL": "1．どの機能に問題が発生したか、またそれがどのような問題だったか、説明してください",
  "CS_1_Closing_Online_tykf": "チャットをオフにする",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Permission_Kapv": "アクセス権限を選択してください",
  "CS_1_Open_automatic_PZyZ": "自動チケット割り当てをオンにする",
  "CS_FE_Ark_Visitor_pMCT": "CRM View Permission",
  "CS_1_Enter_text_NYGo": "ご入力ください",
  "CS_status_WEAx_MWhv": "安全性",
  "CS_System_lIGK_Ukwr": "現在のスキルタイプ",
  "CS_optimazation_Telephone_workstations_TBZP": "コール用Workbench",
  "CS_system_Name_of_QEFT": "ポジション名",
  "CS_status_dweh_wRWT": "店舗契約レビュー",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Sorry_permissions_nBRG": "申し訳ありませんが、システムへのアクセス権限がありません。権限をリクエストする場合は、以下の手順に従ってください。",
  "CS_optimazation__work_JhhB": "{{work_status}}で{{time_duration}}分以上経過しています。まだ{{work_status}}で作業しますか？",
  "CS_Workbench_Online_Customer_yXxN": "チャットサポートワークベンチ",
  "CS_status_wfIq_oGhU": "ソーシャルメディア",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Production_and_mGLI": "下記より権限のタイプを選び「申請」をクリックしてください。\n\nカスタマーサービス商品担当および開発チームの場合：「PM and DEV Role」を選択してください\n\nその他の場合（IBT商品および開発、オペレーション、または国内スタッフ）：「CRM View Permission (Role ID: 14211591)」を選択してください",
  "CS_optimazation_Time_out_sqTe": "タイムアウトのリマインダー",
  "CS_1_Country_ilYw": "国",
  "CS_1_Closed_automatic_jUvk": "自動チケット割り当てをオフにする",
  "CS_1_System_Category_rAJC": "ビジネスカテゴリ",
  "CS_status_aobY_gRor": "{{status_name}}で{{hour_time}}時間以上経過しています。まだ{{status_name}}で作業しますか？",
  "CS_FE_If_you_lCHy": "カスタマーサービス商品担当および開発チームメンバーの場合：",
  "CS_status_qORz_iUKj": "回収",
  "CS_optimazation_The_status_hqOj": "ステータスを切り替えられませんでした。Genesysにログインしてください。",
  "CS_optimazation_After_the_dZsk": "コール後処理",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_vLUC": "カスタマーサービス担当の場合：",
  "CS_feedback_Please_upload_zHqW": "2．問題を確認できる完全な画像データをアップロードしてください",
  "CS_system_Sectoral_information_JizK": "部門情報",
  "CS_optimazation__zXnN": "{{work_status}}タイムアウト",
  "CS_status_eJtD_Xawt": "テクニカルサポート",
  "CS_1_Personal_settings_eXQD": "個人設定",
  "CS_optimazation_Asynchronous_workstations_JwBF": "書面用Workbench",
  "CS_status_YyJG_Khkr": "フロントラインカスタマーサービス",
  "CS_FE_Product_R_RxVt": "PM and DEV Role",
  "CS_1_Online_Customer_SvgB": "チャットはオンになっています",
  "CS_status_pySZ_YnQN": "コンテンツレビュー",
  "CS_1_Open_Online_umkV": "チャットをオンにする",
  "CS_1_Languages_hMbf": "言語",
  "CS_system_Immediate_superior_VDep": "管理責任者",
  "CS_1_Personal_settings_uOXW": "個人設定",
  "CS_FE_Choose_Ark_VJpl": "「CRM View Permission (Role ID: 14211591)」を選択してください",
  "CS_1_Permissions_MuvF": "権限",
  "CS_FE_If_you_WAuP": "その他の担当の場合（IBT商品および開発、オペレーション、または中国拠点のスタッフなど）：",
  "CS_status_ocdu_QQQW": "ビデオ通話",
  "CS_1_Automatic_Order_Mnnv": "自動チケット割り当てはオンになっています",
  "CS_optimazation_Make_sure_FVAQ": "{{workbench_name}}のステータスを本当に{{status_one}}から{{status_two}}に切り替えますか？切り換えると、Workbenchのステータスは{{status_three}}に設定されます。",
  "CS_1_Comments_RcMN": "送信",
  "CS_1_Notification_uJTM": "メッセージ",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Hello_permissions_SDxI": "上司またはカスタマーサービス権限を担当する現地の管理者に問い合わせてください。",
  "status_400": "食事休憩",
  "refreshPage": "ページを更新する",
  "countDownBegin": "Operation after ",
  "infoChange": "別のページでシステムカテゴリが切り替えられました。システムは変更を保存できません。ページを更新してください。",
  "view": "表示",
  "online": "オンライン環境",
  "message": "メッセージ",
  "changeStatusV1": "勤務状態を",
  "changeStatusV2": "から",
  "changeStatusV3": "に変更してよろしいですか？",
  "time": "日付",
  "continue": "続行",
  "knowledge": "知識ベース更新周知",
  "status_500": "休憩時間",
  "artificial": "ダイレクトメッセージ",
  "countDownEnd": "S",
  "clickStartWorking": "データの正確性を確保するため、システムを使用する前に「開始する」をタップしてください",
  "statusChange": "チケットを自動で受け付ける場合は、勤務状態を「対応可」に変更してください。",
  "CS_Workbench_There_are_wmir": "作業ステータスを変更できません。先に実行中のチャットをすべて完了してください。",
  "type": "メッセージタイプ",
  "status_200": "研修時間",
  "cancel": "キャンセル",
  "logout": "終了する",
  "sendTo": "宛先",
  "satisfaction_content": "You have a survey that might take you about 5 minutes to finish. If you would like to complete it now, you can click the link below or the continue button to go to the survey page.",
  "CS_Workbench_Open_the_lnHa": "开启在线客服功能，需要将工作状态切换为“工作中”。",
  "ticketNumber": " 件の処理待ちチケットがあります",
  "more": "More",
  "satisfaction_title": "A survey for you",
  "pre": "イベント前の環境",
  "customerService": "カスタマーサポート",
  "status_300": "対応時間",
  "sendFrom": "差出人",
  "youhave": "",
  "startWorking": "開始する",
  "small": "受け入れ環境",
  "offWorkV": "オフラインにしてよろしいですか？オフラインにすると、本日は退勤となります。",
  "read": "Have read",
  "Settings": "設定",
  "welcomeCS": "DiDiグローバルカスタマーサービスシステムへようこそ！",
  "cs-micro-front-end---more": "",
  "cs-micro-front-end---welcomeCS": "",
  "cs-micro-front-end---clickStartWorking": "",
  "cs-micro-front-end---startWorking": "",
  "cs-micro-front-end---status_200": "",
  "cs-micro-front-end---status_300": "",
  "cs-micro-front-end---status_400": "",
  "cs-micro-front-end---status_500": "",
  "cs-micro-front-end---offWorkV": "",
  "cs-micro-front-end---changeStatusV1": "",
  "cs-micro-front-end---changeStatusV2": "",
  "cs-micro-front-end---changeStatusV3": "",
  "cs-micro-front-end---cancel": "",
  "cs-micro-front-end---continue": "",
  "cs-micro-front-end---logout": "",
  "cs-micro-front-end---online": "",
  "cs-micro-front-end---pre": "",
  "cs-micro-front-end---small": "",
  "cs-micro-front-end---statusChange": "",
  "cs-micro-front-end---youhave": "",
  "cs-micro-front-end---ticketNumber": "",
  "cs-micro-front-end---view": "",
  "cs-micro-front-end---Settings": "",
  "cs-micro-front-end---infoChange": "",
  "cs-micro-front-end---refreshPage": "",
  "cs-micro-front-end---satisfaction_title": "",
  "cs-micro-front-end---satisfaction_content": "",
  "cs-micro-front-end---knowledge": "",
  "cs-micro-front-end---customerService": "",
  "cs-micro-front-end---artificial": "",
  "cs-micro-front-end---sendFrom": "",
  "cs-micro-front-end---sendTo": "",
  "cs-micro-front-end---type": "",
  "cs-micro-front-end---time": "",
  "cs-micro-front-end---read": "",
  "cs-micro-front-end---countDownBegin": "",
  "cs-micro-front-end---countDownEnd": "",
  "cs-micro-front-end---CS_Workbench_There_are_wmir": "",
  "cs-micro-front-end---CS_Workbench_Open_the_lnHa": "",
  "cs-micro-front-end---message": ""
}